/**
 * Unhandled error that cannot be known by the application
 */
export class UnknownError extends Error { }

/**
 * Error about promise
 */
export class PromiseError extends Error { }
/**
 * Rejected promise error
 */
export class RejectionError extends PromiseError { }

// App errors
export class PurchaseOrderDoesntExists extends Error { }
export class InvalidArgumentException extends Error { }
export class LogicException extends Error { }
export class MissingHTMLElement extends Error { }
export class MissingLivewireHTMLElement extends MissingHTMLElement { }
export class UserNotFoundException extends Error { }
export class InvalidWindowContentError extends Error { }

// Livewire errors
export interface TLivewireError {
    body: string;
    errors: null | Record<string, unknown>;
    json: null | string;
    status: number;
}

export class LivewireError extends Error { }
export class InvalidLivewireResponseFormat extends LivewireError { }
export class InvalidLivewireResponseArgument extends LivewireError { }
